<div class="my-card" [hidden]="hide" [ngClass]="{'none-user': !user || !user.id}">
  <!-- <app-box-arrow></app-box-arrow> -->
  <div class="content" *ngIf="user && user.id" [ngStyle]="{'background-image':'url('+(cardBackground | absUrl)+')'}">

    <div class="info">
      <div class="d-flex align-items-center" style="margin: 4px 0;">
        <!-- <div> {{ user | json }}</div> -->
        <!-- <div class="left mr-1" *ngIf="user.badge && user.roleId > 0 && !user.officalUp">
          <img class="dn-badge" src="{{user.badge|absUrl}}" />
        </div>
        <div class="left mr-1" *ngIf="user.officalUp">
          <img class="dn-badge" src="{{'./assets/images/officalUp.png?v=10' | absUrl }}"/>
        </div> -->
        <div class="fs-16 mb-1 nickname">{{ user.nickname ? user.nickname : user.name }}
          <i class="iconfont icon-size" [ngClass]="{
          'iconnanxing': user.gender === 'male',
          'iconnvxing': user.gender === 'female'}"> </i>
        </div>
        <app-membership-icon *ngIf="user.membership && user.roleId > 0"
          class="ml-2"
          [membership]="user.membership"
          [noText]="true" [newIcon]="true"
          [canHover]="true">
        </app-membership-icon>

        <!-- <span class="from">{{ user.from }}</span> -->
      </div>
      <!-- <div class="line">
                <div class="left">
                    <span>等级</span>
                </div>
                <div class="d-inline"
                     appUserLevel
                     [userLevel]="user.level"></div>

            </div> -->

      <div class="line coin-icon">
        <!-- <div class="left">
                    <span></span>
                </div> -->
        <span>{{ user.dnCoins }}</span>
        <span class="vipleft" [innerHTML]="user.daysLeftOfMembership"></span>
      </div>
      <div class="line level-icon">
        <!-- <div class="left">
                    <span></span>
                </div> -->
        <div class="progress">
          <div class="progress-bar"
            [style.width.%]="user.expToNextLevel>0?user.experience  / user.expToNextLevel *100:0">
          </div>
        </div>
        <div class="right text-sm"><span>{{ user.experience | chineseCounter }}</span> /
          <span>{{ user.expToNextLevel | chineseCounter }}</span></div>
      </div>
    </div>
    <!--
    <div class="user-level">
      LV.<span>{{user.level}}</span>
    </div> -->

    <app-membership-icon *ngIf="user.roleId > 0 && !user.officalUp"
      class="avatar-icon"
      [membership]="'premium'"
      [noText]="true" [newIcon]="true">
    </app-membership-icon>
    <app-membership-icon *ngIf="user.roleId > 0 && user.officalUp"
      class="avatar-icon"
      [membership]="'bigV'"
      [noText]="true" [newIcon]="true">
    </app-membership-icon>
    <div class="user-level" [ngClass]="'user-level-' + user.level">
    </div>
  </div>

  <div class="footer" *ngIf="user && user.id && user._isCurrentUser">

    <div class="pull-left d-flex align-items-center h-100">
      <a [routerLink]="['/user']" class="user-center">个人中心<i class="iconfont iconjiantou_liebiaoxiangyou"></i></a>
    </div>
    <div class="pull-right small">
      <a href="javascript:void(0);" (click)="logout()">
        <div class="iconfont icondengchu"></div>
        登出
      </a>
    </div>
    <div class="clear"></div>
  </div>

  <div class="none-user-content" *ngIf="!user || !user.id">
    <div class="login-header" (click)="login()">
      立即登录
      <i class="iconfont iconjiantou_liebiaoxiangyou"></i>
    </div>
    <div class="login-text">观看记录多端同步 尊享高清观影体验</div>
    <div class="login-inner-box">
      <div class="inner-top">
        <div class="vip-promt-icon"></div>
        <div class="vip-promt">
          <div class="promt-text">现在购买，立享VIP<span *ngIf="discountText">限时{{ discountText }}</span></div>
          <div class="promt-text-sub">最低仅需{{ !!discountPerday ? discountPerday : '0.26' }}€/天</div>
        </div>
        <div class="vip-recharge-btn" (click)="openRechargeBox()">
          立即开通
        </div>
      </div>
      <div class="inner-bottom">
        <div class="d-flex align-items-center mr-2">
          <span class="vip-right-icon vip-adfree" [ngClass]="{'light': !isDark}"></span>
          <span class="fs-12">广告特权</span>
        </div>
        <div class="d-flex align-items-center mr-2">
          <span class="vip-right-icon vip-4K" [ngClass]="{'light': !isDark}"></span>
          <span class="fs-12">4K超清</span>
        </div>
        <div class="d-flex align-items-center mr-2">
          <span class="vip-right-icon vip-download" [ngClass]="{'light': !isDark}"></span>
          <span class="fs-12">离线下载</span>
        </div>
        <div class="d-flex align-items-center mr-2">
          <span class="vip-right-icon vip-zungui" [ngClass]="{'light': !isDark}"></span>
          <span class="fs-12">尊贵标识</span>
        </div>
      </div>
    </div>
  </div>

  <!-- <div class="content" *ngIf="isLoading">
        <div class="avatar loading"></div>
        <div class="info">
            <div class="text-bold mb-2 nickname loading"></div>
            <div class="d-flex mb-3 mem-from loading"></div>
            <div class="d-flex mb-2 level loading"></div>
            <div class="d-flex coins loading"></div>
        </div>
    </div> -->
  <!-- <img class="close-btn"
         src="./assets/images/closeme.png"
         alt="关闭"
         (click)="hideMyCard()"> -->
</div>
